

import React, { useState } from 'react';
import PaymentTable from './PaymentTable';
import PaymentForm from './PaymentForm';

const Payments = () => {
  const [currentPage, setCurrentPage] = useState('table'); // 'table', 'addForm', 'editForm'
  const [editingPayment, setEditingPayment] = useState(null);

  const handleAddPayment = () => {
    setEditingPayment(null);
    setCurrentPage('addForm');
  };

  const handleEditPayment = (payment) => {
    setEditingPayment(payment);
    setCurrentPage('editForm');
  };

  const handleDeletePayment = (paymentId) => {
    // Implement delete functionality here
    console.log('Delete payment with ID:', paymentId);
  };

  const handleSuccess = () => {
    setCurrentPage('table');
    setEditingPayment(null);
  };

  const handleCancel = () => {
    setCurrentPage('table');
    setEditingPayment(null);
  };

  if (currentPage === 'addForm') {
    return <PaymentForm onSuccess={handleSuccess} onCancel={handleCancel} />;
  }

  if (currentPage === 'editForm') {
    return <PaymentForm editPayment={editingPayment} onSuccess={handleSuccess} onCancel={handleCancel} />;
  }

  return (
    <PaymentTable 
      onAddPayment={handleAddPayment}
      onEditPayment={handleEditPayment}
      onDeletePayment={handleDeletePayment}
    />
  );
};

export default Payments;